import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=10c4c63a&scoped=true"
var script = {}
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=10c4c63a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4c63a",
  null
  
)

export default component.exports